import styled from "styled-components";

export const Divider = styled.div`
    width: 100%;
    height: 1px;
    background-color: ${p => p.color || '#313C4E'};
    margin: 5px 0;
`